import { render, staticRenderFns } from "./yesWorkbookEdit.vue?vue&type=template&id=c904f656"
import script from "./yesWorkbookEdit.vue?vue&type=script&lang=js"
export * from "./yesWorkbookEdit.vue?vue&type=script&lang=js"
import style0 from "./yesWorkbookEdit.vue?vue&type=style&index=0&id=c904f656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports